import React from "react";
export const new_game_cutout = (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
    >
        <path
            id="rect2084"
            d="M.173.072v24h24v-24ZM12.435,1.738a4.238,4.238,0,0,1,3.424,2.889A3.429,3.429,0,0,1,15.5,6.869l-.59,1.174,1.646,1.441A8.394,8.394,0,0,1,18.2,11.176c0,.138-.787.3-1.746.36l-1.743.109.547,1.981c.439,1.592.961,2.389,2.652,4.053,2.106,2.072,3,3.577,2.654,4.476-.269.7-15.995.7-16.264,0-.345-.9.548-2.4,2.654-4.476,1.691-1.664,2.213-2.461,2.652-4.053l.547-1.981-1.743-.109c-.959-.06-1.744-.222-1.746-.36A8.394,8.394,0,0,1,8.311,9.484L9.957,8.043l-.59-1.174a3.429,3.429,0,0,1-.356-2.242,4.238,4.238,0,0,1,3.424-2.889Z"
            transform="translate(-0.173 -0.072)"
        />
    </svg>
);
